<template>
  <div class="category-backbutton">
    <a href="#top">
      <img class="" src="@/assets/img/down-triangle-pointer.svg" alt="" />
    </a>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.category-backbutton {
  text-align: center;
  margin-top: 40px;
  margin-bottom: -40px;
}
.category-backbutton img {
  transform: rotate(180deg);
  width: 20vw;
  height: auto;
}
</style>
